import { render } from "./BusinessScopesPanel.vue?vue&type=template&id=d4e31664&scoped=true"
import script from "./BusinessScopesPanel.vue?vue&type=script&lang=js"
export * from "./BusinessScopesPanel.vue?vue&type=script&lang=js"

import "./BusinessScopesPanel.vue?vue&type=style&index=0&id=d4e31664&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d4e31664"

export default script